/* unplugin-vue-components disabled */import { render } from "./UserNickname.vue?vue&type=template&id=09c7044f&scoped=true"
import script from "./UserNickname.vue?vue&type=script&lang=js"
export * from "./UserNickname.vue?vue&type=script&lang=js"

import "./UserNickname.vue?vue&type=style&index=0&id=09c7044f&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/zeta-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c7044f"]])

export default __exports__